<template>
  <div class="ourhistory">
    <div
      class="mobile-show"
      style="
    width: 100vw;
    height: calc(100vw * 0.125);
    position:absolute;
    top:0;
    background: url(./img/mobile_header_bg1.jpg) center top  / cover;
    background-repeat: no-repeat;
    "
    ></div>

    <div class="container mobile-hide">
      <agile
        ref="imagecarousel"
        :autoplay="false"
        :speed="2000"
        :fade="true"
        :dots="false"
        :nav-buttons="false"
        style="height:400px;overflow:hidden;"
      >
        <div
          class="slide"
          style="background: url('./img/about_slide01.jpg') center center / cover;"
        ></div>
        <div
          class="slide"
          style="background: url('./img/about_slide02.jpg') center center / cover;"
        ></div>
        <div
          class="slide"
          style="background: url('./img/about_slide03.jpg') center center / cover;"
        ></div>
        <div
          class="slide"
          style="background: url('./img/about_slide04.jpg') center center / cover;"
        ></div>
      </agile>
      <div class="slidetextbg"></div>
      <div class="slidetext tablet-offset">{{$t('body.about_slide')}}</div>
      <div
        style="
      width: 100%;
      height: 133px;
      position: absolute;
      top: 370px;
      background: url(./img/about_overlay.png) center center / cover;
      mix-blend-mode:multiply;
      "
      ></div>
      <div class="container" style="position:absolute;top:0;right:0;">
        <agile
          :autoplay="true"
          :speed="2000"
          :autoplay-speed="5000"
          :fade="true"
          :dots="true"
          :nav-buttons="false"
          style="height:500px;overflow:hidden;"
          @beforeChange="syncslide"
        >
          <div class="slide" style="width:100%;height:500px;">
            <div class="slide-overlay">
              <img src="img/chinese_vision.png" alt width="48" />
            </div>
          </div>
          <div class="slide" style="width:100%;height:500px;">
            <div class="slide-overlay">
              <img src="img/chinese_trust.png" alt width="48" />
            </div>
          </div>
          <div class="slide" style="width:100%;height:500px;">
            <div class="slide-overlay">
              <img src="img/chinese_persist.png" alt width="48" />
            </div>
          </div>
          <div class="slide" style="width:100%;height:500px;">
            <div class="slide-overlay">
              <img src="img/chinese_determin.png" alt width="48" />
            </div>
          </div>
        </agile>
      </div>
    </div>
    <div class="mobile-unpad">
      <div
        class="container mobile-padding mobile-bg-blue"
        style="text-align:left;padding-top:40px;"
      >
        <span class="title-size">{{$t('body.aboutus_history_title')}}</span>
        <div class="subtitlebodyblue" style="margin-bottom:30px;">{{$t('body.aboutus_history_p1')}}</div>
      </div>
      <div
        class="container mobile-padding"
        style="text-align:left;padding-top:24px;margin-bottom:16px;"
      >
        <div class="columns bodygrey">
          <div class="column mobile-column-padding-right" style="text-align:left;">
            <div class="column-child" @mouseenter="hilight" @mouseleave="hilight">
              <div class="container middle-separator-left line-bottom-left">1986</div>
              <div>{{$t('body.aboutus_history_1986p1')}}</div>
            </div>
            <div class="column-child" @mouseenter="hilight" @mouseleave="hilight">
              <div class="container middle-separator-left line-bottom-left">1997</div>
              <div>{{$t('body.aboutus_history_1997p1')}}</div>
            </div>
            <div class="column-child" @mouseenter="hilight" @mouseleave="hilight">
              <div class="container middle-separator-left line-bottom-left">2000</div>
              <div>{{$t('body.aboutus_history_2000p1')}}</div>
            </div>
            <div class="column-child" @mouseenter="hilight" @mouseleave="hilight">
              <div class="container middle-separator-left line-bottom-left">2002</div>
              <div>{{$t('body.aboutus_history_2002p1')}}</div>
            </div>
            <div class="column-child" @mouseenter="hilight" @mouseleave="hilight">
              <div class="container middle-separator-left line-bottom-left">2005</div>
              <div>{{$t('body.aboutus_history_2005p1')}}</div>
            </div>
            <div class="column-child" @mouseenter="hilight" @mouseleave="hilight">
              <div class="container middle-separator-left line-bottom-left">2010</div>
              <div>{{$t('body.aboutus_history_2010p1')}}</div>
            </div>
            <div class="column-child" @mouseenter="hilight" @mouseleave="hilight">
              <div class="container middle-separator-left line-bottom-left">2011</div>
              <div>{{$t('body.aboutus_history_2011p1')}}</div>
            </div>
          </div>

          <div class="column" style="text-align:left;">
            <div class="column-child" @mouseenter="hilight" @mouseleave="hilight">
              <div class="container middle-separator-left line-bottom-left">2012</div>
              <div>{{$t('body.aboutus_history_2012p1')}}</div>
            </div>
            <div class="column-child" @mouseenter="hilight" @mouseleave="hilight">
              <div class="container middle-separator-left line-bottom-left">2014</div>
              <div>{{$t('body.aboutus_history_2014p1')}}</div>
            </div>
            <div class="column-child" @mouseenter="hilight" @mouseleave="hilight">
              <div class="container middle-separator-left line-bottom-left">2015</div>
              <div>{{$t('body.aboutus_history_2015p1')}}</div>
            </div>
            <div class="column-child" @mouseenter="hilight" @mouseleave="hilight">
              <div class="container middle-separator-left line-bottom-left">2016</div>
              <div>{{$t('body.aboutus_history_2016p1')}}</div>
            </div>
            <div class="column-child" @mouseenter="hilight" @mouseleave="hilight">
              <div class="container middle-separator-left line-bottom-left">2017</div>
              <div>{{$t('body.aboutus_history_2017p1')}}</div>
            </div>
            <div class="column-child" @mouseenter="hilight" @mouseleave="hilight">
              <div class="container middle-separator-left line-bottom-left">2018</div>
              <div>{{$t('body.aboutus_history_2018p1')}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="margin-bottom:60px;"></div>
    <div style="position:relative;top:170px;">
      <vfooter></vfooter>
    </div>
  </div>
</template>


<script>
// @ is an alias to /src
import HelloWorld from "@/components/HelloWorld.vue";
export default {
  name: "vision",
  mounted() {
    // let self = this;
    // console.log("hello");
    // bulmaSteps.attach();
  },
  methods: {
    hilight(e) {
      console.log(e.target.children[0]);
      let el = e.target;
      let el1 = e.target.children[0];
      el.classList.toggle("blue");
      el1.classList.toggle("blue");
    },
    syncslide() {
      let self = this;
      console.log("syncslide");
      self.$refs.imagecarousel.goToNext();
    }
  }
};
</script>


<style scoped lang="scss">
.slide {
  width: 100%;
  height: 400px;
  // background: url("../assets/logo.png");
}

.slidetextbg {
  width: 500px;
  height: 400px;
  background: linear-gradient(to right, #013d57dd 70%, #013d5700);
  mix-blend-mode: multiply;
  position: absolute;
  top: 0;
  left: 0;
  color: white;
  text-align: justify;
  padding: 24px 200px 0 24px;
  font-size: 20px;
}

.slidetext {
  width: 550px;
  height: 400px;
  position: absolute;
  top: 0;
  left: 0;
  color: white;
  text-align: left;
  line-height: 29px;
  padding: 24px 200px 0 24px;
  font-size: 25px;
}
.slide-overlay {
  width: calc(1000px - 126px);
  height: inherit;
  font-size: 40px;
  line-height: 1;
  text-align: right;
  color: white;
  border-right: white solid 1px;
  position: relative;
  padding: 0 8px;
  top: 24px;
  // right: -500px;
}

.slide-overlay::after {
  content: "";
  display: block;
  width: 4px;
  height: 100px;
  background: white;
  position: absolute;
  padding-right: 4px;
  top: 0;
  right: 0;
}

.middle-separator-left {
  color: #aaa;
  font-size: 26px;
  padding-bottom: 3px;
  text-align: left;
  line-height: 1.7;
  margin-top: 16px;
  margin-bottom: 16px;
  transition: all 300ms ease-in-out;
}
.line-bottom-left {
  border-bottom: 1px solid #aaa;
  position: relative;
  transition: all 300ms ease-in-out;
}
.line-bottom-left:before {
  content: "";
  display: block;
  width: 60px;
  height: 8px;
  background: #aaa;
  position: absolute;
  bottom: 0;
  left: 0;
  transition: all 300ms ease-in-out;
}

.column-child.blue {
  color: #6d6e70;
}
.middle-separator-left.blue {
  color: #aaa;
  transition: all 300ms ease-in-out;
}
.line-bottom-left.blue {
  border-bottom: 1px solid #aaa;
  position: relative;
  transition: all 300ms ease-in-out;
}
.line-bottom-left.blue:before {
  content: "";
  display: block;
  width: 60px;
  height: 8px;
  background: #aaa;
  position: absolute;
  bottom: 0;
  left: 0;
  transition: all 300ms ease-in-out;
}
@media screen and (min-width: 768px) {
  .column-child.blue {
    color: #013d57;
  }
  .middle-separator-left.blue {
    color: #013d57;
    transition: all 300ms ease-in-out;
  }
  .line-bottom-left.blue {
    border-bottom: 1px solid #013d57;
    position: relative;
    transition: all 300ms ease-in-out;
  }
  .line-bottom-left.blue:before {
    content: "";
    display: block;
    width: 60px;
    height: 8px;
    background: #013d57;
    position: absolute;
    bottom: 0;
    left: 0;
    transition: all 300ms ease-in-out;
  }
  .tablet-offset{
    top:30px;
  }
}
@media screen and (min-width: 992px) {
  .tablet-offset{
    top:0px;
  }
}
</style>